@charset "UTF-8";
:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._next-main-top-bar_vwjwb_8 {
  flex-direction: column;
  color: #000624; }
  ._top-bar-wrapper_vwjwb_11 > ._next-main-top-bar_vwjwb_8 {
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 10px 0 rgba(0, 0, 0, 0.08), 0 1px 20px 0 rgba(0, 0, 0, 0.08); }
  ._next-main-top-bar_vwjwb_8 ._top-bar-menu-bar-wrapper_vwjwb_13 {
    display: flex;
    height: 100%; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-menu-bar-wrapper_vwjwb_13._with-separator_vwjwb_16:after {
      content: '';
      height: 55%;
      align-self: center;
      border-right: 1px solid #dfe5eb; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-menu-bar-wrapper_vwjwb_13 ._top-bar-drop-down-panel_vwjwb_21 ._bubble-content_vwjwb_21 {
      padding-left: 0; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-menu-bar-wrapper_vwjwb_13 ._top-bar-drop-down-panel_code_vwjwb_23 ._bubble-content_vwjwb_21 {
      padding: 0;
      min-width: 360px;
      min-height: 180px; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-left-wix-logo_vwjwb_27 {
    border: none;
    padding: 0 11px;
    margin-right: 6px; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-menu-bar-item_vwjwb_31 {
    font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    padding: 0 15px;
    height: 44px;
    line-height: 44px; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-menu-bar-item_vwjwb_31._active_vwjwb_40 {
      color: #116dff;
      background: #fff; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-menu-bar-clickable-item_vwjwb_43:hover {
    color: #116dff;
    background: #fff; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46 {
    border: none;
    padding: 0 15px;
    height: 44px; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._toggled_vwjwb_50 ._label_vwjwb_50 {
      color: #116dff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._toggled_vwjwb_50 ._btn-symbol_vwjwb_52,
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._toggled_vwjwb_50 ._btn-symbol_vwjwb_52 path {
      fill: #116dff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._toggled_vwjwb_50 ._top-bar-btn-content-wrapper_vwjwb_55:after {
      height: 3px;
      width: 100%;
      background-color: #116dff;
      content: '';
      position: absolute;
      bottom: 0;
      left: 0; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._toggled_vwjwb_50._top-bar-symbol-btn_vwjwb_63 ._btn-symbol_vwjwb_52 {
      border-bottom: none;
      padding-top: 0;
      height: auto; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-menu-bar-item_vwjwb_31._menu-bar-upgrade-item_vwjwb_67 {
    color: #9a27d5; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-menu-bar-item_vwjwb_31._menu-bar-upgrade-item_vwjwb_67:hover {
      color: #c161f0; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-menu-bar-item_vwjwb_31._menu-bar-upgrade-item_vwjwb_67._active_vwjwb_40 {
      color: #c161f0; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73 {
    color: #fff;
    fill: #fff;
    background-color: #116dff;
    padding: 0 24px; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73:hover {
      background-color: #5999ff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73:hover ._label_vwjwb_50 {
        color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73:hover ._action-success-symbol_vwjwb_82 {
        background-color: #116dff; }
        ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73:hover ._action-success-symbol_vwjwb_82 > ._symbol-mask_vwjwb_84 {
          background-color: #5999ff; }
        ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73:hover ._action-success-symbol_vwjwb_82 ._circle_vwjwb_86 {
          border-color: #fff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73._disabled_vwjwb_88, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73._disabled_vwjwb_88:hover {
      background-color: #bcbcbc;
      border-color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73._disabled_vwjwb_88 ._label_vwjwb_50, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73._disabled_vwjwb_88:hover ._label_vwjwb_50 {
        color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73._disabled_vwjwb_88 ._action-success-symbol_vwjwb_82 ._symbol-mask_vwjwb_84, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73._disabled_vwjwb_88:hover ._action-success-symbol_vwjwb_82 ._symbol-mask_vwjwb_84 {
        background-color: #bcbcbc; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73 ._action-success-symbol_vwjwb_82 {
      background-color: #116dff;
      height: auto; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73 ._action-success-symbol_vwjwb_82 ._checkmark-symbol_vwjwb_98 {
        background-color: transparent; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73 ._action-success-symbol_vwjwb_82 ._symbol-mask_vwjwb_84 {
        background-color: #116dff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73 ._action-success-symbol_vwjwb_82 ._circle_vwjwb_86 {
        border-color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73 ._action-success-symbol_vwjwb_82 ._check_vwjwb_98 {
        fill: #fff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-btn-devmode_vwjwb_106 {
      margin-right: 0;
      padding: 0 21px 0 24px; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109 {
    color: #fff;
    fill: #fff;
    background-color: #116dff;
    padding: 0 24px;
    border-left: 1px solid #80b1ff;
    padding: 0 12px; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109:hover {
      background-color: #5999ff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109:hover ._label_vwjwb_50 {
        color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109:hover ._action-success-symbol_vwjwb_82 {
        background-color: #116dff; }
        ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109:hover ._action-success-symbol_vwjwb_82 > ._symbol-mask_vwjwb_84 {
          background-color: #5999ff; }
        ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109:hover ._action-success-symbol_vwjwb_82 ._circle_vwjwb_86 {
          border-color: #fff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109._disabled_vwjwb_88, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109._disabled_vwjwb_88:hover {
      background-color: #bcbcbc;
      border-color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109._disabled_vwjwb_88 ._label_vwjwb_50, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109._disabled_vwjwb_88:hover ._label_vwjwb_50 {
        color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109._disabled_vwjwb_88 ._action-success-symbol_vwjwb_82 ._symbol-mask_vwjwb_84, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109._disabled_vwjwb_88:hover ._action-success-symbol_vwjwb_82 ._symbol-mask_vwjwb_84 {
        background-color: #bcbcbc; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109 ._action-success-symbol_vwjwb_82 {
      background-color: #116dff;
      height: auto; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109 ._action-success-symbol_vwjwb_82 ._checkmark-symbol_vwjwb_98 {
        background-color: transparent; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109 ._action-success-symbol_vwjwb_82 ._symbol-mask_vwjwb_84 {
        background-color: #116dff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109 ._action-success-symbol_vwjwb_82 ._circle_vwjwb_86 {
        border-color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109 ._action-success-symbol_vwjwb_82 ._check_vwjwb_98 {
        fill: #fff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109 ._symbol_vwjwb_84 {
      width: 10px;
      height: 10px; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-btn_vwjwb_147 {
    color: #fff;
    fill: #fff;
    background-color: #e7f0ff;
    padding: 0 24px;
    margin-right: 0;
    padding: 0 21px 0 24px; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-btn_vwjwb_147 ._label_vwjwb_50 {
      color: #116dff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-btn_vwjwb_147:hover {
      background-color: #d6e6fe; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-btn_vwjwb_147:hover ._label_vwjwb_50 {
        color: #116dff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-btn_vwjwb_147._disabled_vwjwb_88, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-btn_vwjwb_147._disabled_vwjwb_88:hover {
      background-color: #f0f0f0;
      border-color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-btn_vwjwb_147._disabled_vwjwb_88 ._label_vwjwb_50, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-btn_vwjwb_147._disabled_vwjwb_88:hover ._label_vwjwb_50 {
        color: #bcbcbc; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-btn_vwjwb_147._disabled_vwjwb_88 svg path {
      fill: #bcbcbc; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167 {
    color: #fff;
    fill: #fff;
    background-color: #e7f0ff;
    padding: 0 24px;
    border-left: 1px solid #116dff;
    padding: 0 12px; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167 ._label_vwjwb_50 {
      color: #116dff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167:hover {
      background-color: #d6e6fe; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167:hover ._label_vwjwb_50 {
        color: #116dff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167._disabled_vwjwb_88, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167._disabled_vwjwb_88:hover {
      background-color: #f0f0f0;
      border-color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167._disabled_vwjwb_88 ._label_vwjwb_50, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167._disabled_vwjwb_88:hover ._label_vwjwb_50 {
        color: #bcbcbc; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167._disabled_vwjwb_88 svg path {
      fill: #bcbcbc; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167 ._symbol_vwjwb_84 {
      width: 10px;
      height: 10px; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167 svg path {
      fill: #116dff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167._disabled_vwjwb_88 {
      border-left: 1px solid #bcbcbc; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-save-btn_vwjwb_194._top-bar-primary-btn_vwjwb_194._top-bar-btn-idle-saved_vwjwb_194, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-save-btn_vwjwb_194._top-bar-primary-btn_vwjwb_194._top-bar-btn-idle-saved_vwjwb_194:hover {
    background-color: #bcbcbc;
    border-color: #fff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-save-btn_vwjwb_194._top-bar-primary-btn_vwjwb_194._top-bar-btn-idle-saved_vwjwb_194 ._label_vwjwb_50, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-save-btn_vwjwb_194._top-bar-primary-btn_vwjwb_194._top-bar-btn-idle-saved_vwjwb_194:hover ._label_vwjwb_50 {
      color: #fff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-save-btn_vwjwb_194._top-bar-primary-btn_vwjwb_194._top-bar-btn-idle-saved_vwjwb_194 ._action-success-symbol_vwjwb_82 ._symbol-mask_vwjwb_84, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-save-btn_vwjwb_194._top-bar-primary-btn_vwjwb_194._top-bar-btn-idle-saved_vwjwb_194:hover ._action-success-symbol_vwjwb_82 ._symbol-mask_vwjwb_84 {
      background-color: #bcbcbc; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194 {
    color: #fff;
    fill: #fff;
    background-color: #116dff;
    padding: 0 24px; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194:hover {
      background-color: #5999ff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194:hover ._label_vwjwb_50 {
        color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194:hover ._action-success-symbol_vwjwb_82 {
        background-color: #116dff; }
        ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194:hover ._action-success-symbol_vwjwb_82 > ._symbol-mask_vwjwb_84 {
          background-color: #5999ff; }
        ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194:hover ._action-success-symbol_vwjwb_82 ._circle_vwjwb_86 {
          border-color: #fff; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194._disabled_vwjwb_88, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194._disabled_vwjwb_88:hover {
      background-color: #bcbcbc;
      border-color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194._disabled_vwjwb_88 ._label_vwjwb_50, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194._disabled_vwjwb_88:hover ._label_vwjwb_50 {
        color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194._disabled_vwjwb_88 ._action-success-symbol_vwjwb_82 ._symbol-mask_vwjwb_84, ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194._disabled_vwjwb_88:hover ._action-success-symbol_vwjwb_82 ._symbol-mask_vwjwb_84 {
        background-color: #bcbcbc; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194 ._action-success-symbol_vwjwb_82 {
      background-color: #116dff;
      height: auto; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194 ._action-success-symbol_vwjwb_82 ._checkmark-symbol_vwjwb_98 {
        background-color: transparent; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194 ._action-success-symbol_vwjwb_82 ._symbol-mask_vwjwb_84 {
        background-color: #116dff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194 ._action-success-symbol_vwjwb_82 ._circle_vwjwb_86 {
        border-color: #fff; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194 ._action-success-symbol_vwjwb_82 ._check_vwjwb_98 {
        fill: #fff; }
  ._next-main-top-bar_vwjwb_8 ._publish-buttons-wrapper_vwjwb_234 {
    display: flex;
    margin-left: 6px; }
  ._next-main-top-bar_vwjwb_8 ._test-site-buttons-wrapper_vwjwb_237 {
    display: flex;
    margin-left: 6px; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-back-to-editor-btn_vwjwb_240 {
    color: #fff;
    background-color: #25a55a;
    padding: 0 24px;
    margin: 0 0 0 12px; }
    ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-back-to-editor-btn_vwjwb_240:hover {
      background-color: #51b77b; }
      ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46._top-bar-back-to-editor-btn_vwjwb_240:hover ._label_vwjwb_50 {
        color: #fff; }
  ._next-main-top-bar_vwjwb_8 ._quick-navigation-pp_vwjwb_249 {
    height: 100%; }
  ._next-main-top-bar_vwjwb_8 ._top-bar-center-notification_vwjwb_251 {
    font-size: 14px;
    height: 44px;
    line-height: 44px; }
  ._next-main-top-bar_vwjwb_8._preview-mode_vwjwb_255 ._top-bar-left-wix-logo_vwjwb_27 {
    padding: 0 17px;
    margin-right: 0; }
  ._next-main-top-bar_vwjwb_8._preview-mode_vwjwb_255 ._top-bar-btn_vwjwb_46._top-bar-save-btn_vwjwb_194 {
    padding: 0 10px 0 11px; }
  ._next-main-top-bar_vwjwb_8._zoom-mode_vwjwb_260 ._top-bar-right-section_vwjwb_260 ._top-bar-btn_vwjwb_46:first-of-type {
    border-left: none;
    margin-left: 3px; }
  ._next-main-top-bar_vwjwb_8._zoom-mode_vwjwb_260 ._top-bar-right-section_vwjwb_260 > *:first-child {
    border-left: none; }
  ._next-main-top-bar_vwjwb_8._zoom-mode_vwjwb_260 ._top-bar-left-section_vwjwb_265 ._top-bar-left-wix-logo_vwjwb_27 {
    border-right: none; }
  ._next-main-top-bar_vwjwb_8._zoom-mode_vwjwb_260 ._top-bar-left-section_vwjwb_265 ._top-bar-left-wix-logo_vwjwb_27 + *:not(._top-bar-center-notification_vwjwb_251) {
    border-left: 1px solid rgba(217, 225, 232, 0.6); }
  ._next-main-top-bar_vwjwb_8._with-rounded-buttons_vwjwb_269 ._top-bar-btn_vwjwb_46._top-bar-back-to-editor-btn_vwjwb_240 {
    height: 30px;
    border-radius: 15px;
    padding: 0 18px;
    margin: 0 12px; }
  ._next-main-top-bar_vwjwb_8._with-rounded-buttons_vwjwb_269 ._top-bar-btn_vwjwb_46._top-bar-publish-btn_vwjwb_73 {
    height: 30px;
    border-radius: 15px;
    padding: 0 18px; }
    ._next-main-top-bar_vwjwb_8._with-rounded-buttons_vwjwb_269 ._top-bar-btn_vwjwb_46._top-bar-publish-btn-devmode_vwjwb_106 {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      padding: 0 15px 0 18px; }
  ._next-main-top-bar_vwjwb_8._with-rounded-buttons_vwjwb_269 ._top-bar-btn_vwjwb_46._top-bar-publish-rc-btn_vwjwb_109 {
    height: 30px;
    border-radius: 15px;
    padding: 0 18px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding: 0 12px 0 10px; }
  ._next-main-top-bar_vwjwb_8._with-rounded-buttons_vwjwb_269 ._top-bar-btn_vwjwb_46._top-bar-test-site-btn_vwjwb_147 {
    height: 30px;
    border-radius: 15px;
    padding: 0 18px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding: 0 15px 0 18px; }
  ._next-main-top-bar_vwjwb_8._with-rounded-buttons_vwjwb_269 ._top-bar-btn_vwjwb_46._top-bar-test-site-rc-btn_vwjwb_167 {
    height: 30px;
    border-radius: 15px;
    padding: 0 18px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding: 0 12px 0 10px; }
  ._next-main-top-bar_vwjwb_8._with-rounded-buttons_vwjwb_269 ._top-bar-btn_vwjwb_46._top-bar-primary-btn_vwjwb_194 {
    height: 30px;
    border-radius: 15px;
    padding: 0 18px; }
  ._next-main-top-bar_vwjwb_8._with-rounded-buttons_vwjwb_269 ._publish-buttons-wrapper_vwjwb_234 {
    margin-left: 12px; }

._top-bar-upper-deck_vwjwb_310,
._top-bar-lower-deck_vwjwb_311 {
  position: relative;
  height: 44px; }
  ._top-bar-upper-deck_vwjwb_310 ._top-bar-left-section_vwjwb_265,
  ._top-bar-upper-deck_vwjwb_310 ._top-bar-center-section_vwjwb_315,
  ._top-bar-upper-deck_vwjwb_310 ._top-bar-right-section_vwjwb_260,
  ._top-bar-lower-deck_vwjwb_311 ._top-bar-left-section_vwjwb_265,
  ._top-bar-lower-deck_vwjwb_311 ._top-bar-center-section_vwjwb_315,
  ._top-bar-lower-deck_vwjwb_311 ._top-bar-right-section_vwjwb_260 {
    z-index: 0;
    display: flex;
    align-items: center;
    height: 100%; }
  ._top-bar-upper-deck_vwjwb_310 ._top-bar-center-section_vwjwb_315,
  ._top-bar-lower-deck_vwjwb_311 ._top-bar-center-section_vwjwb_315 {
    flex-shrink: 1; }
    ._top-bar-upper-deck_vwjwb_310 ._top-bar-center-section_vwjwb_315._intro-fixparent_vwjwb_327,
    ._top-bar-lower-deck_vwjwb_311 ._top-bar-center-section_vwjwb_315._intro-fixparent_vwjwb_327 {
      transform: translateX(-50%) !important;
      z-index: 1000000000 !important; }
      ._top-bar-upper-deck_vwjwb_310 ._top-bar-center-section_vwjwb_315._intro-fixparent_vwjwb_327 > *:not(._tour-maker-highlight-element_vwjwb_331),
      ._top-bar-lower-deck_vwjwb_311 ._top-bar-center-section_vwjwb_315._intro-fixparent_vwjwb_327 > *:not(._tour-maker-highlight-element_vwjwb_331) {
        opacity: 0; }
  ._top-bar-upper-deck_vwjwb_310 ._top-bar-left-section_vwjwb_265._with-separators_vwjwb_334 > *,
  ._top-bar-lower-deck_vwjwb_311 ._top-bar-left-section_vwjwb_265._with-separators_vwjwb_334 > * {
    border-right: 1px solid rgba(217, 225, 232, 0.6); }
  ._top-bar-upper-deck_vwjwb_310 ._top-bar-center-section_vwjwb_315._with-separators_vwjwb_334 > *,
  ._top-bar-lower-deck_vwjwb_311 ._top-bar-center-section_vwjwb_315._with-separators_vwjwb_334 > * {
    border-right: 1px solid rgba(217, 225, 232, 0.6); }
    ._top-bar-upper-deck_vwjwb_310 ._top-bar-center-section_vwjwb_315._with-separators_vwjwb_334 > *:first-child,
    ._top-bar-lower-deck_vwjwb_311 ._top-bar-center-section_vwjwb_315._with-separators_vwjwb_334 > *:first-child {
      border-left: 1px solid rgba(217, 225, 232, 0.6); }
  ._top-bar-upper-deck_vwjwb_310 ._top-bar-right-section_vwjwb_260._with-separators_vwjwb_334 > *,
  ._top-bar-lower-deck_vwjwb_311 ._top-bar-right-section_vwjwb_260._with-separators_vwjwb_334 > * {
    border-left: 1px solid rgba(217, 225, 232, 0.6); }

._top-bar-upper-deck_vwjwb_310 {
  z-index: 1;
  display: flex;
  justify-content: space-between; }
  ._top-bar-upper-deck_vwjwb_310 ._top-bar-right-section_vwjwb_260 {
    padding-right: 16px; }

._top-bar-lower-deck_vwjwb_311 {
  z-index: 0;
  border-top: 1px solid rgba(217, 225, 232, 0.6);
  display: grid;
  grid-template-columns: auto minmax(350px, 1fr) auto;
  grid-template-areas: 'left center right'; }
  ._top-bar-lower-deck_vwjwb_311 ._top-bar-left-section_vwjwb_265 {
    grid-area: left; }
  ._top-bar-lower-deck_vwjwb_311 ._top-bar-center-section_vwjwb_315 {
    overflow: hidden;
    grid-area: center; }
  ._top-bar-lower-deck_vwjwb_311 ._top-bar-right-section_vwjwb_260 {
    grid-area: right; }

._classic-facelift-skin_vwjwb_368 ._next-main-top-bar_vwjwb_8._zoom-mode_vwjwb_260 ._top-bar-left-section_vwjwb_265 ._top-bar-left-wix-logo_vwjwb_27 + *:not(._top-bar-center-notification_vwjwb_251) {
  border-left-color: #dfe5eb; }

._classic-facelift-skin_vwjwb_368 ._top-bar-upper-deck_vwjwb_310,
._classic-facelift-skin_vwjwb_368 ._top-bar-lower-deck_vwjwb_311 {
  border-color: #dfe5eb; }
  ._classic-facelift-skin_vwjwb_368 ._top-bar-upper-deck_vwjwb_310 ._top-bar-left-section_vwjwb_265._with-separators_vwjwb_334 > *,
  ._classic-facelift-skin_vwjwb_368 ._top-bar-upper-deck_vwjwb_310 ._top-bar-right-section_vwjwb_260._with-separators_vwjwb_334 > *,
  ._classic-facelift-skin_vwjwb_368 ._top-bar-upper-deck_vwjwb_310 ._top-bar-center-section_vwjwb_315._with-separators_vwjwb_334 > *,
  ._classic-facelift-skin_vwjwb_368 ._top-bar-lower-deck_vwjwb_311 ._top-bar-left-section_vwjwb_265._with-separators_vwjwb_334 > *,
  ._classic-facelift-skin_vwjwb_368 ._top-bar-lower-deck_vwjwb_311 ._top-bar-right-section_vwjwb_260._with-separators_vwjwb_334 > *,
  ._classic-facelift-skin_vwjwb_368 ._top-bar-lower-deck_vwjwb_311 ._top-bar-center-section_vwjwb_315._with-separators_vwjwb_334 > * {
    border-color: #dfe5eb; }

@media (max-width: 1100px) {
  ._next-main-top-bar_vwjwb_8 ._top-bar-menu-bar-item_vwjwb_31,
  ._next-main-top-bar_vwjwb_8 ._top-bar-btn_vwjwb_46 {
    padding: 0 12px; } }

@media (max-width: 980px) {
  ._next-main-top-bar_vwjwb_8 ._top-bar-front-section_vwjwb_388 {
    background-color: #ffffff;
    z-index: 1; } }

._top-bar-device-switch-with-resize_vwjwb_392 {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center; }

._device-switch-slider_vwjwb_398 {
  padding: 4px 10px;
  width: 78px;
  transition: width 0.2s, padding 0.2s, margin 0.2s;
  overflow: hidden; }
  ._device-switch-slider_vwjwb_398._hidden_vwjwb_403 {
    width: 0;
    padding: 0;
    margin: 0; }

._fluid-preview-controls_vwjwb_408 {
  display: flex;
  align-items: center;
  border-right: 1px solid rgba(217, 225, 232, 0.6); }

._top-bar-menu_vwjwb_13 {
  padding: 0 3px;
  cursor: pointer;
  margin-top: 2px; }

._top-bar-menu_vwjwb_13:hover path,
._top-bar-menu_vwjwb_13._toggled_vwjwb_50 path {
  fill: #116dff; }

._top-bar-btn-device_vwjwb_422 {
  min-width: 36px; }
  ._top-bar-btn-device_vwjwb_422.top-bar-btn {
    padding: 0;
    margin: 0 6px; }
    ._top-bar-btn-device_vwjwb_422.top-bar-btn._topBarBtnFullScreen_vwjwb_427 {
      margin-right: 0; }
  ._top-bar-btn-device_vwjwb_422 .top-bar-btn-content-wrapper > div {
    height: 24px; }
  ._top-bar-btn-device_vwjwb_422 .top-bar-btn-content-wrapper:after {
    display: none; }
  ._top-bar-btn-device_vwjwb_422.toggled::after {
    --hover-size: 34px;
    z-index: 0;
    content: '';
    width: var(--hover-size);
    height: var(--hover-size);
    border-radius: 4px;
    pointer-events: none;
    position: absolute;
    background-color: #116dff;
    opacity: 0.1;
    left: calc(50% - var(--hover-size) / 2);
    top: calc(50% - var(--hover-size) / 2); }
